// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import InfoCircleFilledSvg from "@ant-design/icons-svg/lib/asn/InfoCircleFilled";
import AntdIcon from "../components/AntdIcon";
const InfoCircleFilled = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: InfoCircleFilledSvg
    });
if (process.env.NODE_ENV !== "production") {
    InfoCircleFilled.displayName = "InfoCircleFilled";
}
export default /*#__PURE__*/ React.forwardRef(InfoCircleFilled);
